import React from 'react';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { addProduct } from '../../redux/product/actions';

const AddProductForm = () => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const dispatch = useDispatch()
    const onSubmit = data => {
        // converting string to number 
        data.price = parseFloat(data.price)
        data.quantity = parseFloat(data.quantity)

        dispatch(addProduct(data))

    }
    return (
        <div className="formContainer">
            <h4 className="formTitle">Add New Product</h4>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 text-[#534F4F]" id="lws-addProductForm">
                {/* <!-- product name --> */}
                <div className="space-y-2">
                    <label for="lws-inputName">Product Name</label>
                    <input className="addProductInput" id="lws-inputName" type="text" {...register("name", { required: true })} required />
                </div>
                {/* <!-- product category --> */}
                <div className="space-y-2">
                    <label for="lws-inputCategory">Category</label>
                    <input className="addProductInput" id="lws-inputCategory" type="text" {...register("category", { required: true })} required />
                </div>
                {/* <!-- product image url --> */}
                <div className="space-y-2">
                    <label for="lws-inputImage">Image Url</label>
                    <input className="addProductInput" id="lws-inputImage" type="text" {...register("url", { required: true })} required />
                </div>
                {/* <!-- price & quantity container --> */}
                <div className="grid grid-cols-2 gap-8 pb-4">
                    {/* <!-- price --> */}
                    <div className="space-y-2">
                        <label for="ws-inputPrice">Price</label>
                        <input className="addProductInput" type="number" id="lws-inputPrice" {...register("price", { required: true })} required />
                    </div>
                    {/* <!-- quantity --> */}
                    <div className="space-y-2">
                        <label for="lws-inputQuantity">Quantity</label>
                        <input className="addProductInput" type="number" id="lws-inputQuantity" {...register("quantity", { required: true })} required />
                    </div>
                </div>
                {/* <!-- submit button --> */}
                <button type="submit" id="lws-inputSubmit" className="submit">Add Product</button>
            </form>
        </div>
    );
};

export default AddProductForm;